import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Clock, XCircle, Store } from 'lucide-react';
import { Button } from '../components/ui';
import { useGetOrderQuery } from '../store/ordersApi';

export default function PedidoConfirmado() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const urlStatus = searchParams.get('status');
  const { data: order, isLoading } = useGetOrderQuery(id ?? '', { skip: !id });

  if (isLoading) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center">
        <p className="text-sm text-slate-500">Confirmando tu pedido...</p>
      </div>
    );
  }

  const paymentStatus = order?.paymentStatus ?? (urlStatus === 'failure' ? 'rejected' : 'pending');
  const isPaid = paymentStatus === 'paid';
  const isRejected = paymentStatus === 'rejected' || paymentStatus === 'cancelled';

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className={`p-3 rounded-full mb-5 ${
        isPaid ? 'bg-emerald-50 border border-emerald-500/20'
        : isRejected ? 'bg-rose-50 border border-rose-500/20'
        : 'bg-amber-50 border border-amber-500/20'
      }`}>
        {isPaid ? <CheckCircle2 className="w-8 h-8 text-emerald-600" />
          : isRejected ? <XCircle className="w-8 h-8 text-rose-600" />
          : <Clock className="w-8 h-8 text-amber-600" />}
      </div>

      <h1 className="font-heading font-extrabold text-2xl md:text-3xl text-slate-900 mb-3">
        {isPaid ? '¡Gracias por tu compra!' : isRejected ? 'El pago no se pudo procesar' : 'Estamos confirmando tu pago'}
      </h1>
      <p className="text-sm md:text-base text-slate-500 max-w-md mb-6">
        {isPaid
          ? 'Tu pedido fue confirmado y ya lo estamos preparando.'
          : isRejected
          ? 'No se pudo completar el pago. Podés intentar de nuevo desde el carrito.'
          : 'Puede tardar unos minutos en confirmarse. Vas a poder ver el estado actualizado en Mis Pedidos.'}
      </p>

      {order && (
        <div className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl shadow-sm p-6 mb-8 text-left space-y-1">
          <p className="text-xs text-slate-500 font-bold uppercase tracking-wider">Pedido</p>
          <p className="text-sm text-slate-700">#{order.id.slice(0, 8)}</p>
          <p className="text-sm text-slate-700">
            Total: ${order.total.toLocaleString('es-AR', { maximumFractionDigits: 0 })}
          </p>
        </div>
      )}

      <Button href="/mi-cuenta" variant="primary" size="lg" leftIcon={<Store className="w-4 h-4" />}>
        Ver mis pedidos
      </Button>
    </div>
  );
}
